module.exports = __webpack_public_path__ + "img/20250813SelmaFynn-48.056ba903.jpg";